import React from 'react';
import {Formik} from "formik";
import Text from "../../Commun/Inputs/Text/Text";

const ResetPassword = (props) => {
    const {postResetPassword, loading, errorState, onBackToLogin} = props

    const initialValues = {
        password: '',
        password_confirmation: ''
    }

    // Extract token and email from URL
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    const email = urlParams.get('email')

    return (
        <div className={'p-3 pb-5'}>
            <p className="text-center mb-4" style={{fontSize: '14px'}}>
                Choisissez un nouveau mot de passe sécurisé.
            </p>
            <Formik initialValues={initialValues} onSubmit={values => postResetPassword({
                ...values,
                token,
                email
            })}>
                {({handleSubmit, errors, touched, handleChange, handleBlur, values}) => (
                    <form onSubmit={handleSubmit} className={'row'}>
                        <div className='col-8 offset-2 mb-4'>
                            <Text
                                type={'password'}
                                name="password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                required
                                label='Nouveau mot de passe'
                                placeholder='Saisissez votre nouveau mot de passe'
                            />
                        </div>
                        <div className='col-8 offset-2 mb-4'>
                            <Text
                                type={'password'}
                                name="password_confirmation"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password_confirmation}
                                required
                                label='Confirmer le mot de passe'
                                placeholder='Confirmez votre nouveau mot de passe'
                            />
                        </div>
                        <div className='col-8 offset-2'>
                            <button type="submit" className={`btn btn-block text-center`} style={{minWidth: 200}}>
                                {
                                    loading ?
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                                        : <>Réinitialiser <span className={'d-inline-block mx-2'}>➜</span></>

                                }
                            </button>
                        </div>
                        <div className='col-12 mt-3 text-center'>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                onBackToLogin && onBackToLogin();
                            }} style={{fontSize: '14px'}}>
                                Retour à la connexion
                            </a>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default ResetPassword;
